
{/* <script>
document.addEventListener("DOMContentLoaded", function () {
  const openSidebar = document.getElementById("openSidebar");
  const closeSidebar = document.getElementById("closeSidebar");
  const overlay = document.getElementById("overlay");
  const sidebar = document.getElementById("sidebar");

  function openDrawer() {
    overlay.classList.add("active");
    sidebar.classList.add("active");
  }
  function closeDrawer() {
    overlay.classList.remove("active");
    sidebar.classList.remove("active");
  }
  openSidebar.addEventListener("click", e => { e.preventDefault(); openDrawer(); });
  closeSidebar.addEventListener("click", closeDrawer);
  overlay.addEventListener("click", closeDrawer);

  // ======= Multi-Area Calculator =======
  const areaList = document.getElementById("areaList");
  const addRowBtn = document.getElementById("addRowBtn");
  const totalAreaEl = document.getElementById("totalArea");
  const useAreaBtn = document.getElementById("useAreaBtn");

  function createAreaRow(index) {
    const div = document.createElement("div");
    div.classList.add("area-row");
    div.innerHTML = `
      <span class="row-number">${index + 1}.</span>
      <input type="number" class="width" placeholder="Width (m)" min="0" step="0.01">
      ×
      <input type="number" class="length" placeholder="Length (m)" min="0" step="0.01">
      =
      <span class="area-value">0.00</span> m²
      <button class="remove-row" ${index === 0 ? 'style="display:none;"' : ''}>×</button>
    `;
    return div;
  }

  function updateRowNumbers() {
    document.querySelectorAll(".area-row .row-number").forEach((num, i) => {
      num.textContent = (i + 1) + ".";
    });
  }

  function calculateTotal() {
    let total = 0;
    document.querySelectorAll(".area-row").forEach(row => {
      const w = parseFloat(row.querySelector(".width").value) || 0;
      const l = parseFloat(row.querySelector(".length").value) || 0;
      const area = w * l;
      row.querySelector(".area-value").textContent = area.toFixed(2);
      total += area;
    });
    totalAreaEl.textContent = total.toFixed(2);
    useAreaBtn.disabled = total <= 0;
  }

  // Create 4 default rows
  for (let i = 0; i < 4; i++) {
    areaList.appendChild(createAreaRow(i));
  }

  addRowBtn.addEventListener("click", () => {
    const count = document.querySelectorAll(".area-row").length;
    if (count >= 10) return;
    areaList.appendChild(createAreaRow(count));
    updateRowNumbers();
  });

  areaList.addEventListener("input", calculateTotal);
  areaList.addEventListener("click", e => {
    if (e.target.classList.contains("remove-row")) {
      e.target.closest(".area-row").remove();
      updateRowNumbers();
      calculateTotal();
    }
  });

  useAreaBtn.addEventListener("click", () => {
    const totalArea = parseFloat(totalAreaEl.textContent) || 0;
    if (totalArea > 0) {
      const sqmInput = document.getElementById("sqmInput");
      sqmInput.value = totalArea.toFixed(2);
      sqmInput.dispatchEvent(new Event("input"));
      closeDrawer();
    }
  });

  calculateTotal();

  // ======= Main Calculator =======
  const sqmPerBox = {{ sqm_per_box }};
  const pricePerBox = {{ price_per_box }};
  //alert(pricePerBox);
  const pricePerSqm = {{ price_per_sqm }};
  //lert(pricePerSqm);
  const sqmInput = document.getElementById('sqmInput');
  const wastageCheckbox = document.getElementById('wastageCheckbox');
  const totalPriceEl = document.getElementById('totalPrice');
  const boxInfo = document.getElementById('boxInfo');
  const addToCartBtn = document.getElementById('addToCartBtn');

  let baseSqmValue = parseFloat(sqmInput.value) || 0;

  function calculate() {
    const sqm = parseFloat(sqmInput.value) || 0;
    const boxes = Math.ceil(sqm / sqmPerBox);
    const total = (boxes * pricePerBox).toFixed(2);
    boxInfo.innerHTML = `📦 ${boxes} boxes (${(boxes * sqmPerBox).toFixed(2)} m²) required`;
    totalPriceEl.innerText = total;
    addToCartBtn.dataset.totalPrice = total;
  }

  sqmInput.addEventListener('input', function() {
    baseSqmValue = parseFloat(sqmInput.value) || 0;
    calculate();
  });

  wastageCheckbox.addEventListener('change', function() {
    sqmInput.value = this.checked ? (baseSqmValue * 1.15).toFixed(2) : baseSqmValue.toFixed(2);
    calculate();
  });

  calculate();

  addToCartBtn.addEventListener('click', function() {
    const sqm = parseFloat(sqmInput.value) || 0;
    const quantity = Math.ceil(sqm / sqmPerBox);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        items: [{
          id: {{ product.selected_or_first_available_variant.id }},
          quantity: quantity,
          properties: {
            'Area (m²)': sqm,
            'Boxes': quantity,
            'Price per m²': `$${pricePerSqm}`,
            'Includes 15% Wastage': wastageCheckbox.checked ? 'Yes' : 'No',
            'Calculated Total ($)': this.dataset.totalPrice
          }
        }]
      })
    })
    .then(res => res.json())
    .then(() => window.location.href = '/cart');
  });
}); 
</script> */}


// ===== TILE CALCULATOR GLOBAL INIT =====
function initTileCalculator() {

  const container = document.getElementById("tile-calculator");
  if (!container || container.dataset.init === "true") return;

  container.dataset.init = "true"; // prevent double init

  const sqmInput = container.querySelector('#sqmInput');
  const wastageCheckbox = container.querySelector('#wastageCheckbox');
  const totalPriceEl = container.querySelector('#totalPrice');
  const boxInfo = container.querySelector('#boxInfo');
  const totalAreaEl = document.getElementById('totalArea');
  const areaList = document.getElementById("areaList");

  const sqmPerBox = parseFloat(container.dataset.sqmPerBox) || 0;
  const pricePerBox = parseFloat(container.dataset.pricePerBox) || 0;
  const pricePerSqm = parseFloat(container.dataset.pricePerSqm) || 0;

  let baseSqmValue = parseFloat(sqmInput?.value) || 0;

  function calculate() {
    const sqm = parseFloat(sqmInput?.value) || 0;
    const boxes = sqmPerBox ? Math.ceil(sqm / sqmPerBox) : 0;
    const total = (boxes * pricePerBox).toFixed(2);

    if (boxInfo) {
      boxInfo.innerHTML = `📦 ${boxes} boxes (${(boxes * sqmPerBox).toFixed(2)} m²) required`;
    }

    if (totalPriceEl) totalPriceEl.innerText = total;
  }

  function calculateTotal() {
    let total = 0;

    document.querySelectorAll(".area-row").forEach(row => {
      const w = parseFloat(row.querySelector(".width")?.value) || 0;
      const l = parseFloat(row.querySelector(".length")?.value) || 0;
      const area = w * l;

      row.querySelector(".area-value").textContent = area.toFixed(2);
      total += area;
    });

    if (totalAreaEl) totalAreaEl.textContent = total.toFixed(2);
  }

  // INPUT EVENTS
  document.addEventListener("input", function(e) {

    if (e.target.id === "sqmInput") {
      baseSqmValue = parseFloat(e.target.value) || 0;
      calculate();
    }

    if (e.target.closest(".area-row input")) {
      calculateTotal();
    }

  });

  // CLICK EVENTS
  document.addEventListener("click", function(e) {

    if (e.target.closest("#openSidebar")) {
      e.preventDefault();
      document.getElementById("overlay")?.classList.add("active");
      document.getElementById("sidebar")?.classList.add("active");
    }

    if (e.target.closest("#closeSidebar") || e.target.closest("#overlay")) {
      document.getElementById("overlay")?.classList.remove("active");
      document.getElementById("sidebar")?.classList.remove("active");
    }

    if (e.target.closest("#useAreaBtn")) {
      const totalArea = parseFloat(totalAreaEl?.textContent) || 0;
      if (totalArea > 0 && sqmInput) {
        sqmInput.value = totalArea.toFixed(2);
        sqmInput.dispatchEvent(new Event("input"));
      }
    }

  });

  if (wastageCheckbox) {
    wastageCheckbox.addEventListener('change', function() {
      sqmInput.value = this.checked
        ? (baseSqmValue * 1.15).toFixed(2)
        : baseSqmValue.toFixed(2);
      calculate();
    });
  }

  calculate();
  calculateTotal();
}

// ===== INITIAL LOAD =====
document.addEventListener("DOMContentLoaded", initTileCalculator);

// ===== AJAX FIX (CRITICAL) =====
document.addEventListener("ajaxComplete", initTileCalculator);

// ENGOTHEME SPECIFIC (IMPORTANT)
$(document).ajaxComplete(function () {
  initTileCalculator();
});